var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('v-progress-circular',{attrs:{"rotate":-90,"size":120,"width":12,"color":"primary","value":_vm.value}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }